import { render, staticRenderFns } from "./MaterialLabelPrintTemplateList.vue?vue&type=template&id=98dc5408&scoped=true&"
import script from "./MaterialLabelPrintTemplateList.vue?vue&type=script&lang=js&"
export * from "./MaterialLabelPrintTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dc5408",
  null
  
)

export default component.exports